export enum WweFolders {
	PAC = 'pac',
	PC = 'pc',
	AC = 'ac'
}

export type WweRcs = NileRcs | CmaRcs | PaRcs | IqRcs | PiRcs | AcPortfolioLibraryRcs | TaxRcs | SharedRcs;

export enum CmaRcs {
	WEALTH_PROJECTIONS = 'era-wealth-projections'
}

export enum PaRcs {
	ESG = 'pa-esg',
	SECURITY_DETAILS = 'pa-security-details',
	RISK = 'pa-risk',
	PERFORMANCE = 'pa-performance',
	DETAILS = 'pa-details',
}

export enum TaxRcs {
	SECURITY_DETAILS_BLK_IDEAS = 'te-blk-ideas',
	SECURITY_DETAILS = 'pa-security-details'
}

export enum SharedRcs {
	TAX_DETAILS = 'tax'
}

export enum IqRcs {
	DETAILS = 'iq-details',
	SECURITY_DETAILS = 'iq-security-details',
	SECURITY_DETAILS_COMPARE = 'iq-security-details-compare',
	FUND_ANALYTICS = 'iq-fund-analytics'
}

export enum NileRcs {
	DETAILS = 'details',
	PERFORMANCE = 'performance',
	RISK = 'risk',
	CORRELATION_MATRIX = 'correlation-matrix',
	SECURITY_DETAILS = 'security-details'
}

export enum PiRcs {
	DETAILS = 'pi-details',
	PERFORMANCE = 'pi-performance',
	RISK = 'pi-risk',
	SECURITY_DETAILS = 'pa-security-details'
}

export enum AcPortfolioLibraryRcs {
	DETAILS = 'acpl-details',
	PERFORMANCE = 'acpl-performance',
	RISK = 'acpl-risk',
	SECURITY_DETAILS = 'acpl-security-details',
	RULES = 'acpl-rules'
}
